<template>
    <div class="page background-style">
        <div class="background-image-style">
            <!-- QrmTool landing photo -->
        </div>
        <div class="landing-title">
            IRIS Contracts
        </div>
        <div class="landing-options">
            <router-link to="/DueDiligence" tag="a" class="option" v-if="$store.getters.isInRoleArr('View_LegalArea/LegalClient/ClientList,LEGAL,LEGAL_MNG,LEGAL_ADM,LEGAL_ASS,LEGAL_ASSISTANT_WITH_REOPEN,ADMIN')">
                <div class="img-icon-wrapper">
                    <img :src="'/static/image/Legal.svg'" class="img-icon">
                </div>
                <div class="option-text">
                    {{$t('components.navigation_bar.title_due_diligence')}}
                </div>
            </router-link>
            <v-divider vertical color="white" class="menu-divider"></v-divider>
            <router-link to="/LandingESign" tag="a" class="option" v-if="$store.getters.isInRoleArr('View_ESignArea/ESign/Index,ADMIN,View_TetrisESignArea/TetrisESign/Index,JLLT_VIEW,HR_ADMIN')">
                <div class="img-icon-wrapper">
                    <img :src="'/static/image/ESign.svg'" class="img-icon">
                </div>
                <div class="option-text">
                    {{$t('components.navigation_bar.title_esign_minus')}}
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Landing",
        data() {
            return {
            };
        },
        methods: {
            fnNavTo(pageto) {
                window.open(pageto, "_blank");
            },
            fnNavToInternal(to) {
                this.$router.push(to);
            },
        },
    };
</script>

<style scoped>
    .background-style {
        background-color: var(--jll-gray);
        background-repeat: no-repeat;
        background-image: url(../../assets/IRIS_background_landing_v2.png);
        background-position: bottom left; /* Cambiado a bottom left */
        background-size: cover;
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        padding-top: 30vh;
        overflow-y: auto;
    }

    .img-icon {
        height: 2vw;
        width: 2vw;
    }

    .img-icon-wrapper {
        display: flex;
        align-items: center;
    }

    .background-style:after {
    position: absolute;
    content: '';
    display: block;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    mix-blend-mode: color-burn;
    z-index: -1;
    background: rgb(144 147 216);
    }

    .menu-divider {
        min-height: 3vw !important;
        max-height: 3vw !important;
        min-width: 0.05vw !important;
        max-width: 0.05vw !important;
    }

    .landing-title {
        font-size: 6vw !important;
        overflow: hidden;
        color: rgb(23, 23, 23);
        font-family: "iris-bold";
    }

    .page {
        display: flex;
        flex-direction: column;
    }

    .landing-options {
        padding: 0.6vw;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-self: center;
        background-color: black;
        border-radius: 10px;
        opacity: 0.9;   
    }

    .landing-options .option {
        cursor: pointer;
        display: flex;
        margin-left: 1.6vw;
        margin-right: 1.6vw;
    }

    .landing-options .option:hover .option-icon {
        background-color: darkgray;
        transition: 0.2s;
        text-shadow: 0 0 0.12vw #fff, 0 0 7vw #fff, 0 0 1vw #fff, 0 0 12.1vw #f00, 0 0 0vw #f00, 0 0 41vw #f00, 0 0 1vw #f00, 0 0 26vw #f00;
    }

    .landing-options .option .option-icon {
        min-height: 24px;
        background-color: lightgray;
        border-radius: 100%;
        transition: 0.2s;
        margin-top: 1vh;
        color: white
    }

    .landing-options .option:hover .option-text {
        opacity: 1;
        padding-top: 0px;
        text-shadow: 0 0 0.12vw #fff, 0 0 7vw #fff, 0 0 1vw #fff, 0 0 12.1vw #f00, 0 0 0vw #f00, 0 0 41vw #f00, 0 0 1vw #f00, 0 0 26vw #f00;

    }

    .landing-options .option .option-text {
        font-size: 2.2vw;
        transition: 0.08s;
        position: relative;
        /* padding-top: 2px; */
        color: white;
        font-family: "iris-medium";
        padding-left: 0.25vw;
        padding-right: 0.25vw;
        display: flex;
        align-items: center
    }


    a:hover {
        transition: 0.2s;
        text-decoration: none;
    }

    a{

    }


</style>
